import { render, staticRenderFns } from "./StaffChoose.vue?vue&type=template&id=6c8833ce&scoped=true"
import script from "./StaffChoose.vue?vue&type=script&lang=js"
export * from "./StaffChoose.vue?vue&type=script&lang=js"
import style0 from "./StaffChoose.vue?vue&type=style&index=0&id=6c8833ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8833ce",
  null
  
)

export default component.exports